import { Component, computed, input } from '@angular/core';
import { TopBarVariant } from '../../types/topbar.types';

@Component({
  selector: 'dsrks-topbar',
  imports: [],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopBarComponent {
  public variant = input.required<TopBarVariant>();

  protected cssClasses = computed(() => ['grid-container', `topbar--${this.variant()}`]);
}
